import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  FormErrorMessage,
} from "@chakra-ui/react";
import { CreatableSelect } from "chakra-react-select";

const ChecklistItemForm = ({ initialData, onSubmit, onCancel, existingCategories = [] }) => {
  const safeData = initialData || {};

  const [label, setLabel] = useState(safeData.label || "");
  const [position, setPosition] = useState(safeData.position || "");
  const [category, setCategory] = useState(safeData.category || "");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setLabel(initialData.label || "");
      setPosition(initialData.position || "");
      setCategory(initialData.category || "");
    }
  }, [initialData]);

  const validate = () => {
    const newErrors = {};
    if (!label.trim()) newErrors.label = "Label is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    onSubmit({
      label: label.trim(),
      position: position === "" ? null : Number(position),
      category: category.trim(),
    });
  };

  const categoryOptions = existingCategories.map((c) => ({
    label: c,
    value: c,
  }));

  return (
    <Box as="form" onSubmit={handleSubmit} p={4}>
      <VStack spacing={6} align="stretch">
        {/* Label */}
        <FormControl isInvalid={errors.label}>
          <FormLabel>Label</FormLabel>
          <Input
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="Enter checklist item label"
          />
          <FormErrorMessage>{errors.label}</FormErrorMessage>
        </FormControl>

        {/* Position */}
        <FormControl>
          <FormLabel>Position</FormLabel>
          <Input
            type="number"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
            placeholder="Optional position"
          />
        </FormControl>

        <FormControl>
          <FormLabel>Category</FormLabel>
          <CreatableSelect
            isClearable
            placeholder="Select or create a category..."
            options={categoryOptions}
            value={category ? { label: category, value: category } : null}
            onChange={(newValue) => setCategory(newValue ? newValue.value : "")}
            onCreateOption={(val) => setCategory((val || "").trim())}
          />
        </FormControl>

        {/* Buttons */}
        <Button type="submit" colorScheme="orange" alignSelf="flex-start">
          Save Checklist Item
        </Button>
        {onCancel && (
          <Button onClick={onCancel} alignSelf="flex-start" variant="ghost">
            Cancel
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default ChecklistItemForm;